import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400" data-testid="auth-loading">
        Verifying session…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
